import { Reducer } from 'redux';
import * as Actions from './actions';
import { IUserState } from './interfaces/user-state';

const userInitialState: IUserState = {
  error: '',
  isSupplier: null
}

export const userReducer: Reducer<IUserState> = (state: IUserState = userInitialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.USER_ACTIONS.FAILURE:
      return { ...state, error: action.error };

    case Actions.USER_ACTIONS.SUCCESS:
      return {
        ...state,
        isSupplier: payload.isSupplier
      };

    default:
      return state;
  }
}
